// // import { useEffect, useState } from "react";
// // import {
// //   Box,
// //   Paper,
// //   Stepper,
// //   Step,
// //   StepLabel,
// //   Button,
// //   Typography,
// //   MenuItem,
// //   TextField,
// //   Grid,
// //   CircularProgress,
// // } from "@mui/material";
// // import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutlined";
// // import { toast } from "react-toastify";
// // import PageHeader from "../../../components/PageHeader/PageHeader";
// // import DataTable from "../../../components/DataTable/DataTable";
// // import usePayrollEntity from "../../../utils/usePayrollEntity";
// // import { fmtRs, fmtMoney } from "../../../utils/payrollFormat";
// // import { useDispatch } from "react-redux";
// // import {
// //   calculatePayroll,
// //   getPayrollPreview,
// //   getPayrollBatchEmployees,
// //   validatePayrollBatch,
// // } from "../../../action/Payroll";
// // import { getLoggedInServiceNo } from "../../../utils/masterDataUtils";
// // import PayrollBreakdownDialog from "../../../components/PayRoll/PayrollBreakdownDialog";

// // const PRIMARY = "#1B5C20";

// // const STEPS = [
// //   { label: "Generate Payroll", description: "Select the payroll period and employee batch to run." },
// //   // { label: "Payroll Calculation", description: "Calculate earnings, deductions, EPF/ETF and PAYE for every employee in the batch." },
// //   // { label: "Payroll Validation", description: "Validate the run against configured rules and flag exceptions." },
// //   // { label: "Payroll Recalculation", description: "Recalculate after resolving any exceptions found during validation." },
// //   { label: "Payroll Preview", description: "Preview the final payroll run before sending it for approval." },
// // ];

// // const PayrollProcessing = () => {
// //   const [activeStep, setActiveStep] = useState(0);
// //   const [running, setRunning] = useState(false);

// //   const [selectedPeriod, setSelectedPeriod] = useState("");
// //   const [selectedBatch, setSelectedBatch] = useState("");

// //   const [preview, setPreview] = useState([]);
// //   const [previewLoading, setPreviewLoading] = useState(false);

// //   const [breakdownOpen, setBreakdownOpen] = useState(false);
// //   const [selectedPayroll, setSelectedPayroll] = useState(null);

// //   // Employees pulled from PayRollBatch/GetPayRollEmpBybatchId for the
// //   // batch chosen in Step 1 — this is the "service numbers from the
// //   // project's own Get API" that the Validation/Recalculation/Preview
// //   // steps run against, instead of anyone typing service numbers by hand.
// //   const [batchEmployees, setBatchEmployees] = useState([]);
// //   const [batchEmployeesLoading, setBatchEmployeesLoading] = useState(false);

// //   // const [validation, setValidation] = useState([]);
// //   // const [validationLoading, setValidationLoading] = useState(false);

// //   const dispatch = useDispatch();

// //   // const { list: preview, loading } = usePayrollEntity("payrollPreview");
// //   const { list: periods } = usePayrollEntity("payrollPeriods");
// //   const { list: batches } = usePayrollEntity("batchManagement");

// //   // Load the selected batch's active employees (service numbers) as soon
// //   // as a batch is picked, so later steps have them ready to call
// //   // PayRollCal/GetPayrollDetailsBySno and Preview/GetPreviewPayroll with.
// //   useEffect(() => {
// //     if (!selectedBatch) {
// //       setBatchEmployees([]);
// //       // setValidation([]);
// //       return;
// //     }

// //     let cancelled = false;
// //     setBatchEmployeesLoading(true);

// //     dispatch(getPayrollBatchEmployees(selectedBatch))
// //       .then((list) => {
// //         if (!cancelled) setBatchEmployees(list);
// //       })
// //       .catch((error) => {
// //         console.error("Failed to load batch employees: ", error);
// //         if (!cancelled) setBatchEmployees([]);
// //       })
// //       .finally(() => {
// //         if (!cancelled) setBatchEmployeesLoading(false);
// //       });

// //     return () => {
// //       cancelled = true;
// //     };
// //   }, [selectedBatch, dispatch]);

// //   useEffect(() => {
// //     if (activeStep !== STEPS.length - 1) {
// //       return;
// //     }

// //     if (!selectedPeriod) return;

// //     const loadPreview = async () => {
// //       setPreviewLoading(true);

// //       try {
// //         const result = await dispatch(
// //           getPayrollPreview(selectedPeriod, batchEmployees)
// //         );

// //         setPreview(result || []);

// //         if (!result || result.length === 0) {
// //           toast.info(
// //             "No employees with salary were found for the selected payroll period."
// //           );
// //         }
// //       } catch (error) {
// //         console.error("Payroll preview error: ", error);

// //         setPreview([]);

// //         toast.error(
// //           error?.message || "Failed to load payroll preview."
// //         );
// //       } finally {
// //         setPreviewLoading(false);
// //       }
// //     }

// //     loadPreview();
// //   }, [activeStep, selectedPeriod, batchEmployees, dispatch]);

// //   const filteredBatches = selectedPeriod 
// //     ? batches.filter(
// //         (batch) => String(batch.periodId) === String(selectedPeriod)
// //       )
// //     : batches;

// //   // const isCalculationStep = activeStep === 1;
// //   // const isValidationStep = activeStep === 2;
// //   // const isRecalculationStep = activeStep === 3;

// //   // const runStep = async () => {
// //   //   if (activeStep === 0) {
// //   //     if (!selectedPeriod) {
// //   //       toast.warning("Please select a payroll period");
// //   //       return;
// //   //     }
// //   //   }

// //   //   if ((isValidationStep || isRecalculationStep) && batchEmployees.length === 0) {
// //   //     toast.warning(
// //   //       "Please select a payroll batch with active employees in Step 1 first."
// //   //     );
// //   //     return;
// //   //   }

// //   //   setRunning(true);

// //   //   try {
// //   //     if (isCalculationStep) {
// //   //       // Runs PayrollCal/CalPayRoll for the whole selected period.
// //   //       await dispatch(calculatePayroll(selectedPeriod, getLoggedInServiceNo()));
// //   //     } else if (isValidationStep || isRecalculationStep) {
// //   //       if (isRecalculationStep) {
// //   //         // Recalculation: re-run the calculation, then re-check every
// //   //         // batch employee's record so exceptions found during
// //   //         // Validation get picked up again.
// //   //         await dispatch(calculatePayroll(selectedPeriod, getLoggedInServiceNo()));
// //   //       }

// //   //       setValidationLoading(true);

// //   //       const results = await dispatch(
// //   //         validatePayrollBatch(selectedPeriod, batchEmployees)
// //   //       );

// //   //       setValidation(results);
// //   //       setValidationLoading(false);

// //   //       const exceptions = results.filter((r) => r.status === "Exception").length;

// //   //       if (exceptions > 0) {
// //   //         toast.warning(
// //   //           `${exceptions} of ${results.length} employee(s) still need attention.`,
// //   //           { autoClose: 2500 }
// //   //         );
// //   //       }
// //   //     } else {
// //   //       // Step 1 (Generate Payroll) has nothing to call yet — the period
// //   //       // and batch are just being selected.
// //   //       await new Promise((resolve) => setTimeout(resolve, 400));
// //   //     }

// //   //     toast.success(`${STEPS[activeStep].label} completed.`, { autoClose: 1800 });
// //   //     setActiveStep((s) => Math.min(s + 1, STEPS.length - 1));
// //   //   } catch (error) {
// //   //     console.error(`${STEPS[activeStep].label} failed: `, error);

// //   //     toast.error(
// //   //       error?.response?.data?.message || error?.response?.data?.Message ||
// //   //       error?.message || `Failed to run ${STEPS[activeStep].label}.`
// //   //     );
// //   //   } finally {
// //   //     setValidationLoading(false);
// //   //     setRunning(false);
// //   //   }
// //   // };

// //   const runStep = async () => {
// //     // Only payroll period is mandatory
// //     if (activeStep === 0) {
// //       if (!selectedPeriod) {
// //         toast.warning("Please select a payroll period");
// //         return;
// //       }
// //     }

// //     setRunning(true);

// //     try {
// //       if (activeStep < STEPS.length - 1) {
// //         // Steps 1 - 4 are navigation only. No payroll calculation logic.
// //         await new Promise((resolve) => setTimeout(resolve, 300));

// //         toast.success(
// //           `${STEPS[activeStep].label} completed.`,
// //           { autoClose: 1800 }
// //         );

// //         setActiveStep((s) => Math.min(s+1, STEPS.length - 1));
// //       }
// //     } finally {
// //       setRunning(false);
// //     }
// //   } 

// //   const isPreviewStep = activeStep === STEPS.length - 1;
// //   const totalGross = preview.reduce((s, r) => s + r.gross, 0);
// //   const totalNet = preview.reduce((s, r) => s + r.net, 0);

// //   const handleSubmitForApproval = async () => {
// //     if (!selectedPeriod) {
// //       toast.warning("Please select a payroll period.");
// //       return;
// //     }

// //     setRunning(true);

// //     try {
// //       await dispatch(calculatePayroll(selectedPeriod, getLoggedInServiceNo()));
      
// //       setPreview([]);

// //       toast.success(
// //         "Payroll generated successfully. The payroll preview has been cleared.",
// //         { autoClose: 2500 }
// //       );

// //       // Return to step 1
// //       setActiveStep(0);
// //     } catch (error) {
// //       console.error("Payroll generation error: ", error);

// //       toast.error(
// //         error?.response?.data?.message || error?.response?.data?.Message ||
// //         error?.message || "Failed to generate payroll."
// //       );
// //     } finally {
// //       setRunning(false);
// //     }
// //   }

// //   return (
// //     <Box>
// //       <PageHeader
// //         icon={<PlayCircleOutlineIcon sx={{ color: PRIMARY, fontSize: 28 }} />}
// //         title="Payroll Processing"
// //         subtitle="Generate, calculate, validate and preview a payroll run before approval."
// //       />

// //       <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: "1px solid #EAEAEA", mb: 3 }}>
// //         <Stepper
// //           activeStep={activeStep}
// //           alternativeLabel
// //           sx={{
// //             mb: 3,
// //             "& .MuiStepIcon-root.Mui-active": { color: PRIMARY },
// //             "& .MuiStepIcon-root.Mui-completed": { color: PRIMARY },
// //           }}
// //         >
// //           {STEPS.map((step) => (
// //             <Step key={step.label}>
// //               <StepLabel>{step.label}</StepLabel>
// //             </Step>
// //           ))}
// //         </Stepper>

// //         {!isPreviewStep && (
// //           <>
// //             <Typography variant="body2" color="#646464" sx={{ mb: 2 }}>
// //               {STEPS[activeStep].description}
// //             </Typography>

// //             {activeStep === 0 && (
// //               <div className="mb-4 grid max-w-[480px] grid-cols-1 gap-4 sm:grid-cols-2">
// //                 {/* Payroll Period */}
// //                 <div className="w-full">
// //                   <label
// //                     htmlFor="payroll-period"
// //                     className="mb-1 block text-sm font-medium text-gray-700"
// //                   >
// //                     Payroll Period
// //                   </label>

// //                   <select
// //                     id="payroll-period"
// //                     value={selectedPeriod}
// //                     onChange={(e) => {
// //                       setSelectedPeriod(e.target.value);
// //                       setSelectedBatch("");
// //                     }}
// //                     className="h-10 w-full rounded-md border border-gray-300 bg-white px-3 text-sm text-gray-700 outline-none transition focus:border-[#1B5C20] focus:ring-1 focus:ring-[#1B5C20]"
// //                   >
// //                     <option value="">Select Payroll Period</option>

// //                     {periods.map((period) => (
// //                       <option key={period.id} value={period.id}>
// //                         {period.code} - {period.name}
// //                       </option>
// //                     ))}
// //                   </select>
// //                 </div>

// //                 {/* Payroll Batch */}
// //                 {/* <div className="w-full">
// //                   <label
// //                     htmlFor="payroll-batch"
// //                     className="mb-1 block text-sm font-medium text-gray-700"
// //                   >
// //                     Payroll Batch
// //                   </label>

// //                   <select
// //                     id="payroll-batch"
// //                     value={selectedBatch}
// //                     onChange={(e) => {
// //                       setSelectedBatch(e.target.value);
// //                     }}
// //                     disabled={!selectedPeriod}
// //                     className="h-10 w-full rounded-md border border-gray-300 bg-white px-3 text-sm text-gray-700 outline-none transition focus:border-[#1B5C20] focus:ring-1 focus:ring-[#1B5C20] disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400"
// //                   >
// //                     <option value="">Select Payroll Batch</option>

// //                     {filteredBatches.map((batch) => (
// //                       <option key={batch.id} value={batch.id}>
// //                         {batch.batchNo} - {batch.name}
// //                       </option>
// //                     ))}
// //                   </select>
// //                 </div> */}
// //               </div>
// //             )}

// //             {activeStep === 0 && selectedBatch && (
// //               <Typography variant="caption" color="#888" sx={{ display: "block", mb: 2 }}>
// //                 {batchEmployeesLoading
// //                   ? "Loading batch employees..."
// //                   : `${batchEmployees.length} active employee(s) in this batch.`}
// //               </Typography>
// //             )}

// //             <Button
// //               variant="contained"
// //               onClick={runStep}
// //               disabled={running}
// //               startIcon={running ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : null}
// //               sx={{
// //                 backgroundColor: PRIMARY,
// //                 textTransform: "none",
// //                 borderRadius: 2,
// //                 px: 3,
// //                 "&:hover": { backgroundColor: "#145016" },
// //               }}
// //             >
// //               {running ? "Processing..." : `Run: ${STEPS[activeStep].label}`}
// //             </Button>

// //             {/* {(isValidationStep || isRecalculationStep) && validation.length > 0 && (
// //               <Box sx={{ mt: 3 }}>
// //                 <DataTable
// //                   loading={validationLoading}
// //                   rows={validation}
// //                   searchKeys={["empNo", "name"]}
// //                   searchPlaceholder="Search employees..."
// //                   pageSize={6}
// //                   columns={[
// //                     { key: "name", label: "Employee", render: (r) => `${r.name} (${r.empNo})` },
// //                     { key: "gross", label: "Gross (Rs)", align: "right", render: (r) => fmtMoney(r.gross) },
// //                     { key: "totalDeductions", label: "Deductions (Rs)", align: "right", render: (r) => fmtMoney(r.totalDeductions) },
// //                     { key: "net", label: "Net Pay (Rs)", align: "right", render: (r) => fmtMoney(r.net) },
// //                     {
// //                       key: "status",
// //                       label: "Status",
// //                       render: (r) => (
// //                         <Typography
// //                           variant="body2"
// //                           sx={{ fontWeight: 600, color: r.status === "OK" ? PRIMARY : "#C62828" }}
// //                         >
// //                           {r.status}
// //                         </Typography>
// //                       ),
// //                     },
// //                     { key: "message", label: "Details" },
// //                   ]}
// //                 />
// //               </Box>
// //             )} */}
// //           </>
// //         )}

// //         {isPreviewStep && (
// //           <>
// //             <Typography variant="body2" color="#646464" sx={{ mb: 2 }}>
// //               {STEPS[activeStep].description} Gross: <b>{fmtMoney(totalGross)}</b> &nbsp;|&nbsp; Net:{" "}
// //               <b style={{ color: PRIMARY }}>{fmtMoney(totalNet)}</b>
// //             </Typography>
// //             <DataTable
// //               loading={previewLoading}
// //               rows={preview}
// //               searchKeys={["empNo", "name"]}
// //               searchPlaceholder="Search employees..."
// //               pageSize={6}
// //               columns={[
// //                 { key: "name", label: "Employee", render: (r) => `${r.name} (${r.empNo})` },
// //                 { key: "workingDays", label: "Working Days", align: "right", render: (r) => r.workingDays },
// //                 { key: "presentDays", label: "Present", align: "right", render: (r) => r.presentDays },
// //                 { key: "gross", label: "Gross (Rs)", align: "right", render: (r) => fmtMoney(r.gross) },
// //                 { key: "totalDeductions", label: "Deductions (Rs)", align: "right", render: (r) => fmtMoney(r.totalDeductions) },
// //                 { key: "epf", label: "EPF (Rs)", align: "right", render: (r) => fmtMoney(r.epf) },
// //                 { key: "net", label: "Net Pay (Rs)", align: "right", render: (r) => fmtMoney(r.net) },

// //                 {
// //                   key: "breakdown",
// //                   label: "Breakdown",
// //                   align: "center",
// //                   render: (r) => (
// //                     <Button
// //                       size="small"
// //                       variant="outlined"
// //                       onClick={() => {
// //                         setSelectedPayroll(r);
// //                         setBreakdownOpen(true);
// //                       }}
// //                       sx={{
// //                         textTransform: "none",
// //                         borderColor: PRIMARY,
// //                         color: PRIMARY,
// //                         borderRadius: 1.5,
// //                         fontSize: "0.75rem",
// //                         "&:hover": {
// //                           borderColor: PRIMARY,
// //                           backgroundColor: "#F0F7F0",
// //                         },
// //                       }}  
// //                     >
// //                       View Breakdown
// //                     </Button>
// //                   )
// //                 }
// //               ]}
// //             />
// //             <Box sx={{ mt: 2, display: "flex", gap: 1.5 }}>
// //               <Button
// //                 variant="outlined"
// //                 onClick={() => setActiveStep(0)}
// //                 sx={{ textTransform: "none", borderColor: PRIMARY, color: PRIMARY, borderRadius: 2 }}
// //               >
// //                 Start New Run
// //               </Button>
// //               <Button
// //                 variant="contained"
// //                 onClick={handleSubmitForApproval}
// //                 disabled={running || previewLoading || preview.length === 0}
// //                 sx={{ backgroundColor: PRIMARY, textTransform: "none", borderRadius: 2, "&:hover": { backgroundColor: "#145016" } }}
// //               >
// //                 { running ? "Generating Payroll..." : "Submit for Approval" }
// //               </Button>
// //             </Box>
// //           </>
// //         )}
// //       </Paper>

// //       <PayrollBreakdownDialog 
// //         open={breakdownOpen}
// //         payroll={selectedPayroll}
// //         onClose={() => {
// //           setBreakdownOpen(false);
// //           setSelectedPayroll(null);
// //         }}
// //       />
// //     </Box>
// //   );
// // };

// // export default PayrollProcessing;


// import { useEffect, useState } from "react";
// import { useDispatch } from "react-redux";
// import {
//   CalendarDays,
//   Play,
//   RefreshCw,
//   Send,
//   Eye,
// } from "lucide-react";
// import { toast } from "react-toastify";

// import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
// import Table from "../../../components/Table/Table";

// import usePayrollEntity from "../../../utils/usePayrollEntity";
// import { fmtMoney } from "../../../utils/payrollFormat";
// import { getLoggedInServiceNo } from "../../../utils/masterDataUtils";
// import {
//   calculatePayroll,
//   getPayrollPreview,
//   getPayrollBatchEmployees,
// } from "../../../action/Payroll";

// import PayrollBreakdownDialog from "../../../components/PayRoll/PayrollBreakdownDialog";
// import Toast from "../../../components/Toast/Toast";
// import useToast from "../../../utils/useToast";
// import PayrollApprovalProgressDialog, { APPROVAL_STATUS } from "../../../components/PayRoll/PayrollApprovalProgressDialog";
// import payRollService from "../../../services/PayrollService";

// const TABLE_PROPS = {
//   search: true,
//   searchLabel: "Search",
//   pageSize: 10,
//   scrollClassName: "",
//   emptyMessage: "No payroll records found",
//   loadingMessage: "Loading...",
// };

// const PayrollProcessing = () => {
//   const dispatch = useDispatch();

//   const [running, setRunning] = useState(false);

//   const [selectedPeriod, setSelectedPeriod] = useState("");
//   const [selectedBatch, setSelectedBatch] = useState("");

//   const [preview, setPreview] = useState([]);
//   const [previewLoading, setPreviewLoading] = useState(false);

//   const [breakdownOpen, setBreakdownOpen] = useState(false);
//   const [selectedPayroll, setSelectedPayroll] = useState(null);

//   const [batchEmployees, setBatchEmployees] = useState([]);
//   const [batchEmployeesLoading, setBatchEmployeesLoading] = useState(false);

//   const [approvalDialogOpen, setApprovalDialogOpen] = useState(false);
//   const [approvalStatus, setApprovalStatus] = useState(APPROVAL_STATUS.IDLE);
//   const [approvalError, setApprovalError] = useState('');

//   const { list: periods } = usePayrollEntity("payrollPeriods");
//   const { list: batches } = usePayrollEntity("batchManagement");

//   const { toast, showToast, hideToast } = useToast();

//   /*
//    * Load employees belonging to the selected batch.
//    */
//   useEffect(() => {
//     if (!selectedBatch) {
//       setBatchEmployees([]);
//       return;
//     }

//     let cancelled = false;

//     setBatchEmployeesLoading(true);

//     dispatch(getPayrollBatchEmployees(selectedBatch))
//       .then((list) => {
//         if (!cancelled) {
//           setBatchEmployees(list || []);
//         }
//       })
//       .catch((error) => {
//         console.error("Failed to load batch employees:", error);

//         if (!cancelled) {
//           setBatchEmployees([]);
//         }
//       })
//       .finally(() => {
//         if (!cancelled) {
//           setBatchEmployeesLoading(false);
//         }
//       });

//     return () => {
//       cancelled = true;
//     };
//   }, [selectedBatch, dispatch]);

//   /*
//    * Load preview whenever a payroll period is selected and
//    * the preview is requested by the existing flow.
//    */
//   useEffect(() => {
//     if (!selectedPeriod) {
//       setPreview([]);
//       return;
//     }

//     const loadPreview = async () => {
//       setPreviewLoading(true);

//       try {
//         const result = await dispatch(
//           getPayrollPreview(selectedPeriod, batchEmployees)
//         );

//         setPreview(result || []);

//         if (!result || result.length === 0) {
//           // toast.info(
//           //   "No employees with salary were found for the selected payroll period."
//           // );

//           showToast("The selected payroll period has already been generated.", 'warning');
//         }
//       } catch (error) {
//         console.error("Payroll preview error:", error);

//         setPreview([]);

//         // toast.error(
//         //   error?.message || "Failed to load payroll preview."
//         // );

//         showToast(error?.message || "Failed to load payroll preview.", 'error');
//       } finally {
//         setPreviewLoading(false);
//       }
//     };

//     loadPreview();
//   }, [selectedPeriod, batchEmployees, dispatch]);

//   const filteredBatches = selectedPeriod
//     ? batches.filter(
//         (batch) =>
//           String(batch.periodId) === String(selectedPeriod)
//       )
//     : batches;

//   const totalGross = preview.reduce(
//     (sum, row) => sum + Number(row.gross || 0),
//     0
//   );

//   const totalNet = preview.reduce(
//     (sum, row) => sum + Number(row.net || 0),
//     0
//   );

//   const handlePeriodChange = (value) => {
//     setSelectedPeriod(value);
//     setSelectedBatch("");
//     setPreview([]);
//   };

//   const handleOpenApprovalDialog = () => {
//     if (!selectedPeriod) {
//       showToast("Please select a payroll period.", "warning");
//       return;
//     }

//     if (preview.length === 0) {
//       showToast("There are no payroll records available for approval.", "warning");
//       return;
//     }

//     setApprovalStatus(APPROVAL_STATUS.IDLE);
//     setApprovalError('');
//     setApprovalDialogOpen(true);
//   }

//   const handleExecuteSubmission = async () => {
//     setRunning(true);

//     try {
//       // 1. Calculate payroll
//       setApprovalStatus(APPROVAL_STATUS.GENERATING_PAYROLL);
//       await dispatch(
//         calculatePayroll(selectedPeriod, getLoggedInServiceNo())
//       );

//       // 2. Generate bank report transfer
//       setApprovalStatus(APPROVAL_STATUS.GENERATING_BANK_REPORT);
//       const bankResponse = await payRollService.GetBankReportDetailsByPeriodId(selectedPeriod);

//       if (bankResponse && bankResponse.StatusCode !== 200) {
//         throw new Error(bankResponse.Result || "Failed to generate bank report.");
//       }

//       // Finished successfully
//       setApprovalStatus(APPROVAL_STATUS.COMPLETED);
//       setPreview([]);
//       setSelectedPeriod("");
//       setSelectedBatch("");
//       setBatchEmployees([]);
//     } catch (error) {
//       console.error("[Payroll Processing] Submission workflow failed: ", error);
//       const msg = 
//         error?.response?.data?.message || 
//         error?.response?.data?.Message || 
//         error?.message ||
//         "Failed to complete payroll submission.";
//       setApprovalError(msg);
//       setApprovalStatus(APPROVAL_STATUS.FAILED); 
//     } finally {
//       setRunning(false);
//     }
//   }

//   const handleRefreshPreview = async () => {
//     if (!selectedPeriod) {
//       // toast.warning("Please select a payroll period.");
//       showToast("Please select a payroll period.", "warning");
//       return;
//     }

//     setPreviewLoading(true);

//     try {
//       const result = await dispatch(
//         getPayrollPreview(
//           selectedPeriod,
//           batchEmployees
//         )
//       );

//       setPreview(result || []);

//       // toast.success("Payroll preview refreshed.", {
//       //   autoClose: 1500,
//       // });
//       showToast("Payroll preview refreshed.", "success");
//     } catch (error) {
//       console.error("Payroll preview error:", error);

//       // toast.error(
//       //   error?.message || "Failed to refresh payroll preview."
//       // );

//       showToast(error?.message || "Failed to refresh payroll preview.", "error");
//     } finally {
//       setPreviewLoading(false);
//     }
//   };

//   const handleSubmitForApproval = async () => {
//     if (!selectedPeriod) {
//       // toast.warning("Please select a payroll period.");
//       showToast("Please select a payroll period.", "warning");
//       return;
//     }

//     if (preview.length === 0) {
//       // toast.warning(
//       //   "There are no payroll records available for approval."
//       // );
//       showToast("There are no payroll records available for approval.", "warning");
//       return;
//     }

//     setRunning(true);

//     try {
//       await dispatch(
//         calculatePayroll(
//           selectedPeriod,
//           getLoggedInServiceNo()
//         )
//       );

//       setPreview([]);

//       // toast.success(
//       //   "Payroll generated successfully. The payroll preview has been cleared.",
//       //   { autoClose: 2500 }
//       // );

//       showToast("Payroll generated successfully. The payroll preview has been cleared.", "success");

//       setSelectedPeriod("");
//       setSelectedBatch("");
//       setBatchEmployees([]);
//     } catch (error) {
//       console.error("Payroll generation error:", error);

//       // toast.error(
//       //   error?.response?.data?.message ||
//       //     error?.response?.data?.Message ||
//       //     error?.message ||
//       //     "Failed to generate payroll."
//       // );

//       showToast(`${error?.response?.data?.message ||
//           error?.response?.data?.Message ||
//           error?.message ||
//           "Failed to generate payroll."}`,"error")
//     } finally {
//       setRunning(false);
//     }
//   };

//   return (
//     <div className="space-y-4 p-6">
//       <Breadcrumb
//         trail={["Payroll", "Payroll Processing"]}
//         title="Payroll Processing"
//         subtitle="Generate payroll and review the final payroll results before approval."
//       />

//       {/* ─────────────────────────────────────────────────────────────
//           Payroll Generation
//       ───────────────────────────────────────────────────────────── */}
//       <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
//         <div className="border-b border-gray-200 px-5 py-4">
//           <div className="flex items-center gap-3">
//             <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-50 text-primary-700">
//               <CalendarDays size={18} />
//             </div>

//             <div>
//               <h2 className="text-sm font-semibold text-gray-900">
//                 Generate Payroll
//               </h2>

//               <p className="mt-0.5 text-xs text-gray-500">
//                 Select a payroll period and generate the payroll
//                 calculation.
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="px-5 py-5">
//           <div className="grid max-w-[720px] grid-cols-1 gap-4 sm:grid-cols-2">
//             {/* Payroll Period */}
//             <div>
//               <label
//                 htmlFor="payroll-period"
//                 className="mb-1.5 block text-xs font-medium text-gray-700"
//               >
//                 Payroll Period
//                 <span className="ml-1 text-red-500">*</span>
//               </label>

//               <select
//                 id="payroll-period"
//                 value={selectedPeriod}
//                 onChange={(e) =>
//                   handlePeriodChange(e.target.value)
//                 }
//                 className="
//                   h-10
//                   w-full
//                   rounded-md
//                   border
//                   border-gray-300
//                   bg-white
//                   px-3
//                   text-sm
//                   text-gray-700
//                   outline-none
//                   transition
//                   focus:border-primary-600
//                   focus:ring-1
//                   focus:ring-primary-600
//                 "
//               >
//                 <option value="">
//                   Select Payroll Period
//                 </option>

//                 {periods
//                   .filter((period) => period.status === "Active")
//                   .map((period) => (
//                     <option
//                       key={period.id}
//                       value={period.id}
//                     >
//                       {period.code} - {period.name}
//                     </option>
//                   ))
//                 }
//               </select>
//             </div>

//             {/* Payroll Batch */}
//             {/*
//             <div>
//               <label
//                 htmlFor="payroll-batch"
//                 className="mb-1.5 block text-xs font-medium text-gray-700"
//               >
//                 Payroll Batch
//               </label>

//               <select
//                 id="payroll-batch"
//                 value={selectedBatch}
//                 onChange={(e) =>
//                   setSelectedBatch(e.target.value)
//                 }
//                 disabled={!selectedPeriod}
//                 className="
//                   h-10
//                   w-full
//                   rounded-md
//                   border
//                   border-gray-300
//                   bg-white
//                   px-3
//                   text-sm
//                   text-gray-700
//                   outline-none
//                   transition
//                   focus:border-primary-600
//                   focus:ring-1
//                   focus:ring-primary-600
//                   disabled:cursor-not-allowed
//                   disabled:bg-gray-100
//                   disabled:text-gray-400
//                 "
//               >
//                 <option value="">
//                   Select Payroll Batch
//                 </option>

//                 {filteredBatches.map((batch) => (
//                   <option
//                     key={batch.id}
//                     value={batch.id}
//                   >
//                     {batch.batchNo} - {batch.name}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             */}
//           </div>

//           {selectedPeriod && (
//             <div className="mt-4 flex flex-wrap items-center gap-3">
//               {/* <Button
//                 type="button"
//                 variant="contained"
//                 onClick={handleGeneratePayroll}
//                 disabled={running}
//                 startIcon={
//                   running ? (
//                     <RefreshCw
//                       size={15}
//                       className="animate-spin"
//                     />
//                   ) : (
//                     <Play size={15} />
//                   )
//                 }
//                 sx={{
//                   backgroundColor: PRIMARY,
//                   textTransform: "none",
//                   borderRadius: 1.5,
//                   boxShadow: "none",
//                   px: 2.5,
//                   "&:hover": {
//                     backgroundColor: "#145016",
//                     boxShadow: "none",
//                   },
//                 }}
//               >
//                 {running
//                   ? "Generating Payroll..."
//                   : "Generate Payroll"}
//               </Button> */}

//               <button
//                 type="button"
//                 onClick={handleRefreshPreview}
//                 disabled={previewLoading || running}
//                 className="
//                   inline-flex
//                   items-center
//                   justify-center
//                   gap-2
//                   rounded-md
//                   border
//                   border-gray-300
//                   bg-white
//                   px-4
//                   py-2.5
//                   text-sm
//                   font-medium
//                   text-gray-600
//                   transition-colors
//                   hover:border-primary-600
//                   hover:bg-primary-50
//                   hover:text-primary-700
//                   disabled:cursor-not-allowed
//                   disabled:bg-gray-100
//                   disabled:text-gray-400
//                 "
//               >
//                 <RefreshCw
//                   size={15}
//                   className={previewLoading ? "animate-spin" : ""}
//                 />

//                 Refresh Preview
//               </button>
//             </div>
//           )}

//           {selectedBatch && (
//             <p className="mt-3 text-xs text-gray-500">
//               {batchEmployeesLoading
//                 ? "Loading batch employees..."
//                 : `${batchEmployees.length} active employee(s) in this batch.`}
//             </p>
//           )}
//         </div>
//       </div>

//       {/* ─────────────────────────────────────────────────────────────
//           Payroll Preview
//       ───────────────────────────────────────────────────────────── */}
//       <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
//         <div className="flex flex-col gap-3 border-b border-gray-200 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
//           <div>
//             <h2 className="text-sm font-semibold text-gray-900">
//               Payroll Preview
//             </h2>

//             <p className="mt-0.5 text-xs text-gray-500">
//               Review calculated payroll amounts before submitting
//               the run for approval.
//             </p>
//           </div>

//           {preview.length > 0 && (
//             <div className="flex flex-wrap items-center gap-5 text-right">
//               <div>
//                 <p className="text-[11px] uppercase tracking-wide text-gray-400">
//                   Employees
//                 </p>
//                 <p className="text-sm font-semibold text-gray-900">
//                   {preview.length}
//                 </p>
//               </div>

//               <div>
//                 <p className="text-[11px] uppercase tracking-wide text-gray-400">
//                   Gross
//                 </p>
//                 <p className="text-sm font-semibold text-gray-900">
//                   {fmtMoney(totalGross)}
//                 </p>
//               </div>

//               <div>
//                 <p className="text-[11px] uppercase tracking-wide text-gray-400">
//                   Net Pay
//                 </p>
//                 <p
//                   className="text-sm font-semibold text-primary-700"
//                 >
//                   {fmtMoney(totalNet)}
//                 </p>
//               </div>
//             </div>
//           )}
//         </div>

//         {!selectedPeriod ? (
//           <div className="px-5 py-12 text-center">
//             <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 text-gray-400">
//               <CalendarDays size={19} />
//             </div>

//             <p className="text-sm font-medium text-gray-700">
//               Select a payroll period
//             </p>

//             <p className="mt-1 text-xs text-gray-500">
//               Choose a payroll period above to generate and preview
//               payroll.
//             </p>
//           </div>
//         ) : (
//           <>
//             <Table
//               {...TABLE_PROPS}
//               loading={previewLoading}
//               rows={preview}
//               rowKey={(row) =>
//                 row.empNo || row.serviceNo || row.id
//               }
//               searchKeys={["empNo", "name"]}
//               searchPlaceholder="Search employees..."
//               columns={[
//                 {
//                   key: "name",
//                   label: "Employee",
//                   grow: true,
//                   className:
//                     "font-semibold text-gray-900",
//                   render: (r) =>
//                     `${r.name} (${r.empNo})`,
//                 },
//                 {
//                   key: "workingDays",
//                   label: "Working Days",
//                   align: "right",
//                   className: "text-gray-600 tabular-nums",
//                   render: (r) =>
//                     r.workingDays,
//                 },
//                 {
//                   key: "presentDays",
//                   label: "Present",
//                   align: "right",
//                   className: "text-gray-600 tabular-nums",
//                   render: (r) =>
//                     r.presentDays,
//                 },
//                 {
//                   key: "gross",
//                   label: "Gross (Rs)",
//                   align: "right",
//                   className:
//                     "font-semibold text-gray-900 tabular-nums",
//                   render: (r) =>
//                     fmtMoney(r.gross),
//                 },
//                 {
//                   key: "totalDeductions",
//                   label: "Deductions (Rs)",
//                   align: "right",
//                   className:
//                     "text-gray-600 tabular-nums",
//                   render: (r) =>
//                     fmtMoney(r.totalDeductions),
//                 },
//                 {
//                   key: "epf",
//                   label: "EPF (Rs)",
//                   align: "right",
//                   className:
//                     "text-gray-600 tabular-nums",
//                   render: (r) =>
//                     fmtMoney(r.epf),
//                 },
//                 {
//                   key: "net",
//                   label: "Net Pay (Rs)",
//                   align: "right",
//                   className:
//                     "font-semibold text-gray-900 tabular-nums",
//                   render: (r) =>
//                     fmtMoney(r.net),
//                 },
//                 {
//                   key: "breakdown",
//                   label: "Breakdown",
//                   align: "center",
//                   render: (r) => (
//                     <button
//                       type="button"
//                       onClick={() => {
//                         setSelectedPayroll(r);
//                         setBreakdownOpen(true);
//                       }}
//                       className="
//                         inline-flex
//                         h-8
//                         items-center
//                         gap-1.5
//                         rounded-md
//                         border
//                         border-gray-200
//                         px-2.5
//                         text-xs
//                         font-medium
//                         text-gray-600
//                         transition-colors
//                         hover:border-primary-200
//                         hover:bg-primary-50
//                         hover:text-primary-700
//                       "
//                     >
//                       <Eye size={14} />
//                       View
//                     </button>
//                   ),
//                 },
//               ]}
//             />

//             {preview.length > 0 && (
//               <div className="flex flex-col gap-2 border-t border-gray-200 px-5 py-4 sm:flex-row sm:items-center sm:justify-end">
//                 <button
//                   type="button"
//                   onClick={() => {
//                     setPreview([]);
//                     setSelectedPeriod("");
//                     setSelectedBatch("");
//                     setBatchEmployees([]);
//                   }}
//                   disabled={running}
//                   className="
//                     inline-flex
//                     items-center
//                     justify-center
//                     rounded-md
//                     border
//                     border-gray-300
//                     bg-white
//                     px-4
//                     py-2.5
//                     text-sm
//                     font-medium
//                     text-gray-600
//                     transition-colors
//                     hover:border-primary-600
//                     hover:bg-primary-50
//                     hover:text-primary-700
//                     disabled:cursor-not-allowed
//                     disabled:bg-gray-100
//                     disabled:text-gray-400
//                   "
//                 >
//                   Start New Run
//                 </button>

//                 <button
//                   type="button"
//                   onClick={handleOpenApprovalDialog}
//                   disabled={
//                     running ||
//                     previewLoading ||
//                     preview.length === 0
//                   }
//                   className="
//                     inline-flex
//                     items-center
//                     justify-center
//                     gap-2
//                     rounded-md
//                     bg-primary-600
//                     px-4
//                     py-2.5
//                     text-sm
//                     font-medium
//                     text-white
//                     transition-colors
//                     hover:bg-primary-700
//                     disabled:cursor-not-allowed
//                     disabled:bg-gray-300
//                     disabled:text-gray-500
//                   "
//                 >
//                   {/*running ? (
//                     <RefreshCw
//                       size={15}
//                       className="animate-spin"
//                     />
//                   ) : (
//                     <Send size={15} />
//                   )}

//                   {running ? "Processing..." : "Submit for Approval" */}

//                   <Send size={15} />
//                   Submit for Approval
//                 </button>
//               </div>
//             )}
//           </>
//         )}
//       </div>

//       <PayrollBreakdownDialog
//         open={breakdownOpen}
//         payroll={selectedPayroll}
//         onClose={() => {
//           setBreakdownOpen(false);
//           setSelectedPayroll(null);
//         }}
//       />

//       <PayrollApprovalProgressDialog 
//         open={approvalDialogOpen}
//         status={approvalStatus}
//         errorMessage={approvalError}
//         onConfirm={handleExecuteSubmission}
//         onClose={() => setApprovalDialogOpen(false)}
//       />

//       <Toast 
//         message={toast?.message}
//         type={toast?.type}
//         onClose={hideToast}
//       />
//     </div>
//   );
// };

// export default PayrollProcessing;


// import { useEffect, useState } from "react";
// import {
//   Box,
//   Paper,
//   Stepper,
//   Step,
//   StepLabel,
//   Button,
//   Typography,
//   MenuItem,
//   TextField,
//   Grid,
//   CircularProgress,
// } from "@mui/material";
// import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutlined";
// import { toast } from "react-toastify";
// import PageHeader from "../../../components/PageHeader/PageHeader";
// import DataTable from "../../../components/DataTable/DataTable";
// import usePayrollEntity from "../../../utils/usePayrollEntity";
// import { fmtRs, fmtMoney } from "../../../utils/payrollFormat";
// import { useDispatch } from "react-redux";
// import {
//   calculatePayroll,
//   getPayrollPreview,
//   getPayrollBatchEmployees,
//   validatePayrollBatch,
// } from "../../../store/slices/payrollSlice";
// import { getLoggedInServiceNo } from "../../../utils/masterDataUtils";
// import PayrollBreakdownDialog from "../../../components/PayRoll/PayrollBreakdownDialog";

// const PRIMARY = "#1B5C20";

// const STEPS = [
//   { label: "Generate Payroll", description: "Select the payroll period and employee batch to run." },
//   // { label: "Payroll Calculation", description: "Calculate earnings, deductions, EPF/ETF and PAYE for every employee in the batch." },
//   // { label: "Payroll Validation", description: "Validate the run against configured rules and flag exceptions." },
//   // { label: "Payroll Recalculation", description: "Recalculate after resolving any exceptions found during validation." },
//   { label: "Payroll Preview", description: "Preview the final payroll run before sending it for approval." },
// ];

// const PayrollProcessing = () => {
//   const [activeStep, setActiveStep] = useState(0);
//   const [running, setRunning] = useState(false);

//   const [selectedPeriod, setSelectedPeriod] = useState("");
//   const [selectedBatch, setSelectedBatch] = useState("");

//   const [preview, setPreview] = useState([]);
//   const [previewLoading, setPreviewLoading] = useState(false);

//   const [breakdownOpen, setBreakdownOpen] = useState(false);
//   const [selectedPayroll, setSelectedPayroll] = useState(null);

//   // Employees pulled from PayRollBatch/GetPayRollEmpBybatchId for the
//   // batch chosen in Step 1 — this is the "service numbers from the
//   // project's own Get API" that the Validation/Recalculation/Preview
//   // steps run against, instead of anyone typing service numbers by hand.
//   const [batchEmployees, setBatchEmployees] = useState([]);
//   const [batchEmployeesLoading, setBatchEmployeesLoading] = useState(false);

//   // const [validation, setValidation] = useState([]);
//   // const [validationLoading, setValidationLoading] = useState(false);

//   const dispatch = useDispatch();

//   // const { list: preview, loading } = usePayrollEntity("payrollPreview");
//   const { list: periods } = usePayrollEntity("payrollPeriods");
//   const { list: batches } = usePayrollEntity("batchManagement");

//   // Load the selected batch's active employees (service numbers) as soon
//   // as a batch is picked, so later steps have them ready to call
//   // PayRollCal/GetPayrollDetailsBySno and Preview/GetPreviewPayroll with.
//   useEffect(() => {
//     if (!selectedBatch) {
//       setBatchEmployees([]);
//       // setValidation([]);
//       return;
//     }

//     let cancelled = false;
//     setBatchEmployeesLoading(true);

//     dispatch(getPayrollBatchEmployees(selectedBatch))
//       .then((list) => {
//         if (!cancelled) setBatchEmployees(list);
//       })
//       .catch((error) => {
//         console.error("Failed to load batch employees: ", error);
//         if (!cancelled) setBatchEmployees([]);
//       })
//       .finally(() => {
//         if (!cancelled) setBatchEmployeesLoading(false);
//       });

//     return () => {
//       cancelled = true;
//     };
//   }, [selectedBatch, dispatch]);

//   useEffect(() => {
//     if (activeStep !== STEPS.length - 1) {
//       return;
//     }

//     if (!selectedPeriod) return;

//     const loadPreview = async () => {
//       setPreviewLoading(true);

//       try {
//         const result = await dispatch(
//           getPayrollPreview(selectedPeriod, batchEmployees)
//         );

//         setPreview(result || []);

//         if (!result || result.length === 0) {
//           toast.info(
//             "No employees with salary were found for the selected payroll period."
//           );
//         }
//       } catch (error) {
//         console.error("Payroll preview error: ", error);

//         setPreview([]);

//         toast.error(
//           error?.message || "Failed to load payroll preview."
//         );
//       } finally {
//         setPreviewLoading(false);
//       }
//     }

//     loadPreview();
//   }, [activeStep, selectedPeriod, batchEmployees, dispatch]);

//   const filteredBatches = selectedPeriod 
//     ? batches.filter(
//         (batch) => String(batch.periodId) === String(selectedPeriod)
//       )
//     : batches;

//   // const isCalculationStep = activeStep === 1;
//   // const isValidationStep = activeStep === 2;
//   // const isRecalculationStep = activeStep === 3;

//   // const runStep = async () => {
//   //   if (activeStep === 0) {
//   //     if (!selectedPeriod) {
//   //       toast.warning("Please select a payroll period");
//   //       return;
//   //     }
//   //   }

//   //   if ((isValidationStep || isRecalculationStep) && batchEmployees.length === 0) {
//   //     toast.warning(
//   //       "Please select a payroll batch with active employees in Step 1 first."
//   //     );
//   //     return;
//   //   }

//   //   setRunning(true);

//   //   try {
//   //     if (isCalculationStep) {
//   //       // Runs PayrollCal/CalPayRoll for the whole selected period.
//   //       await dispatch(calculatePayroll(selectedPeriod, getLoggedInServiceNo()));
//   //     } else if (isValidationStep || isRecalculationStep) {
//   //       if (isRecalculationStep) {
//   //         // Recalculation: re-run the calculation, then re-check every
//   //         // batch employee's record so exceptions found during
//   //         // Validation get picked up again.
//   //         await dispatch(calculatePayroll(selectedPeriod, getLoggedInServiceNo()));
//   //       }

//   //       setValidationLoading(true);

//   //       const results = await dispatch(
//   //         validatePayrollBatch(selectedPeriod, batchEmployees)
//   //       );

//   //       setValidation(results);
//   //       setValidationLoading(false);

//   //       const exceptions = results.filter((r) => r.status === "Exception").length;

//   //       if (exceptions > 0) {
//   //         toast.warning(
//   //           `${exceptions} of ${results.length} employee(s) still need attention.`,
//   //           { autoClose: 2500 }
//   //         );
//   //       }
//   //     } else {
//   //       // Step 1 (Generate Payroll) has nothing to call yet — the period
//   //       // and batch are just being selected.
//   //       await new Promise((resolve) => setTimeout(resolve, 400));
//   //     }

//   //     toast.success(`${STEPS[activeStep].label} completed.`, { autoClose: 1800 });
//   //     setActiveStep((s) => Math.min(s + 1, STEPS.length - 1));
//   //   } catch (error) {
//   //     console.error(`${STEPS[activeStep].label} failed: `, error);

//   //     toast.error(
//   //       error?.response?.data?.message || error?.response?.data?.Message ||
//   //       error?.message || `Failed to run ${STEPS[activeStep].label}.`
//   //     );
//   //   } finally {
//   //     setValidationLoading(false);
//   //     setRunning(false);
//   //   }
//   // };

//   const runStep = async () => {
//     // Only payroll period is mandatory
//     if (activeStep === 0) {
//       if (!selectedPeriod) {
//         toast.warning("Please select a payroll period");
//         return;
//       }
//     }

//     setRunning(true);

//     try {
//       if (activeStep < STEPS.length - 1) {
//         // Steps 1 - 4 are navigation only. No payroll calculation logic.
//         await new Promise((resolve) => setTimeout(resolve, 300));

//         toast.success(
//           `${STEPS[activeStep].label} completed.`,
//           { autoClose: 1800 }
//         );

//         setActiveStep((s) => Math.min(s+1, STEPS.length - 1));
//       }
//     } finally {
//       setRunning(false);
//     }
//   } 

//   const isPreviewStep = activeStep === STEPS.length - 1;
//   const totalGross = preview.reduce((s, r) => s + r.gross, 0);
//   const totalNet = preview.reduce((s, r) => s + r.net, 0);

//   const handleSubmitForApproval = async () => {
//     if (!selectedPeriod) {
//       toast.warning("Please select a payroll period.");
//       return;
//     }

//     setRunning(true);

//     try {
//       await dispatch(calculatePayroll(selectedPeriod, getLoggedInServiceNo()));
      
//       setPreview([]);

//       toast.success(
//         "Payroll generated successfully. The payroll preview has been cleared.",
//         { autoClose: 2500 }
//       );

//       // Return to step 1
//       setActiveStep(0);
//     } catch (error) {
//       console.error("Payroll generation error: ", error);

//       toast.error(
//         error?.response?.data?.message || error?.response?.data?.Message ||
//         error?.message || "Failed to generate payroll."
//       );
//     } finally {
//       setRunning(false);
//     }
//   }

//   return (
//     <Box>
//       <PageHeader
//         icon={<PlayCircleOutlineIcon sx={{ color: PRIMARY, fontSize: 28 }} />}
//         title="Payroll Processing"
//         subtitle="Generate, calculate, validate and preview a payroll run before approval."
//       />

//       <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: "1px solid #EAEAEA", mb: 3 }}>
//         <Stepper
//           activeStep={activeStep}
//           alternativeLabel
//           sx={{
//             mb: 3,
//             "& .MuiStepIcon-root.Mui-active": { color: PRIMARY },
//             "& .MuiStepIcon-root.Mui-completed": { color: PRIMARY },
//           }}
//         >
//           {STEPS.map((step) => (
//             <Step key={step.label}>
//               <StepLabel>{step.label}</StepLabel>
//             </Step>
//           ))}
//         </Stepper>

//         {!isPreviewStep && (
//           <>
//             <Typography variant="body2" color="#646464" sx={{ mb: 2 }}>
//               {STEPS[activeStep].description}
//             </Typography>

//             {activeStep === 0 && (
//               <div className="mb-4 grid max-w-[480px] grid-cols-1 gap-4 sm:grid-cols-2">
//                 {/* Payroll Period */}
//                 <div className="w-full">
//                   <label
//                     htmlFor="payroll-period"
//                     className="mb-1 block text-sm font-medium text-gray-700"
//                   >
//                     Payroll Period
//                   </label>

//                   <select
//                     id="payroll-period"
//                     value={selectedPeriod}
//                     onChange={(e) => {
//                       setSelectedPeriod(e.target.value);
//                       setSelectedBatch("");
//                     }}
//                     className="h-10 w-full rounded-md border border-gray-300 bg-white px-3 text-sm text-gray-700 outline-none transition focus:border-[#1B5C20] focus:ring-1 focus:ring-[#1B5C20]"
//                   >
//                     <option value="">Select Payroll Period</option>

//                     {periods.map((period) => (
//                       <option key={period.id} value={period.id}>
//                         {period.code} - {period.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div>

//                 {/* Payroll Batch */}
//                 {/* <div className="w-full">
//                   <label
//                     htmlFor="payroll-batch"
//                     className="mb-1 block text-sm font-medium text-gray-700"
//                   >
//                     Payroll Batch
//                   </label>

//                   <select
//                     id="payroll-batch"
//                     value={selectedBatch}
//                     onChange={(e) => {
//                       setSelectedBatch(e.target.value);
//                     }}
//                     disabled={!selectedPeriod}
//                     className="h-10 w-full rounded-md border border-gray-300 bg-white px-3 text-sm text-gray-700 outline-none transition focus:border-[#1B5C20] focus:ring-1 focus:ring-[#1B5C20] disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400"
//                   >
//                     <option value="">Select Payroll Batch</option>

//                     {filteredBatches.map((batch) => (
//                       <option key={batch.id} value={batch.id}>
//                         {batch.batchNo} - {batch.name}
//                       </option>
//                     ))}
//                   </select>
//                 </div> */}
//               </div>
//             )}

//             {activeStep === 0 && selectedBatch && (
//               <Typography variant="caption" color="#888" sx={{ display: "block", mb: 2 }}>
//                 {batchEmployeesLoading
//                   ? "Loading batch employees..."
//                   : `${batchEmployees.length} active employee(s) in this batch.`}
//               </Typography>
//             )}

//             <Button
//               variant="contained"
//               onClick={runStep}
//               disabled={running}
//               startIcon={running ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : null}
//               sx={{
//                 backgroundColor: PRIMARY,
//                 textTransform: "none",
//                 borderRadius: 2,
//                 px: 3,
//                 "&:hover": { backgroundColor: "#145016" },
//               }}
//             >
//               {running ? "Processing..." : `Run: ${STEPS[activeStep].label}`}
//             </Button>

//             {/* {(isValidationStep || isRecalculationStep) && validation.length > 0 && (
//               <Box sx={{ mt: 3 }}>
//                 <DataTable
//                   loading={validationLoading}
//                   rows={validation}
//                   searchKeys={["empNo", "name"]}
//                   searchPlaceholder="Search employees..."
//                   pageSize={6}
//                   columns={[
//                     { key: "name", label: "Employee", render: (r) => `${r.name} (${r.empNo})` },
//                     { key: "gross", label: "Gross (Rs)", align: "right", render: (r) => fmtMoney(r.gross) },
//                     { key: "totalDeductions", label: "Deductions (Rs)", align: "right", render: (r) => fmtMoney(r.totalDeductions) },
//                     { key: "net", label: "Net Pay (Rs)", align: "right", render: (r) => fmtMoney(r.net) },
//                     {
//                       key: "status",
//                       label: "Status",
//                       render: (r) => (
//                         <Typography
//                           variant="body2"
//                           sx={{ fontWeight: 600, color: r.status === "OK" ? PRIMARY : "#C62828" }}
//                         >
//                           {r.status}
//                         </Typography>
//                       ),
//                     },
//                     { key: "message", label: "Details" },
//                   ]}
//                 />
//               </Box>
//             )} */}
//           </>
//         )}

//         {isPreviewStep && (
//           <>
//             <Typography variant="body2" color="#646464" sx={{ mb: 2 }}>
//               {STEPS[activeStep].description} Gross: <b>{fmtMoney(totalGross)}</b> &nbsp;|&nbsp; Net:{" "}
//               <b style={{ color: PRIMARY }}>{fmtMoney(totalNet)}</b>
//             </Typography>
//             <DataTable
//               loading={previewLoading}
//               rows={preview}
//               searchKeys={["empNo", "name"]}
//               searchPlaceholder="Search employees..."
//               pageSize={6}
//               columns={[
//                 { key: "name", label: "Employee", render: (r) => `${r.name} (${r.empNo})` },
//                 { key: "workingDays", label: "Working Days", align: "right", render: (r) => r.workingDays },
//                 { key: "presentDays", label: "Present", align: "right", render: (r) => r.presentDays },
//                 { key: "gross", label: "Gross (Rs)", align: "right", render: (r) => fmtMoney(r.gross) },
//                 { key: "totalDeductions", label: "Deductions (Rs)", align: "right", render: (r) => fmtMoney(r.totalDeductions) },
//                 { key: "epf", label: "EPF (Rs)", align: "right", render: (r) => fmtMoney(r.epf) },
//                 { key: "net", label: "Net Pay (Rs)", align: "right", render: (r) => fmtMoney(r.net) },

//                 {
//                   key: "breakdown",
//                   label: "Breakdown",
//                   align: "center",
//                   render: (r) => (
//                     <Button
//                       size="small"
//                       variant="outlined"
//                       onClick={() => {
//                         setSelectedPayroll(r);
//                         setBreakdownOpen(true);
//                       }}
//                       sx={{
//                         textTransform: "none",
//                         borderColor: PRIMARY,
//                         color: PRIMARY,
//                         borderRadius: 1.5,
//                         fontSize: "0.75rem",
//                         "&:hover": {
//                           borderColor: PRIMARY,
//                           backgroundColor: "#F0F7F0",
//                         },
//                       }}  
//                     >
//                       View Breakdown
//                     </Button>
//                   )
//                 }
//               ]}
//             />
//             <Box sx={{ mt: 2, display: "flex", gap: 1.5 }}>
//               <Button
//                 variant="outlined"
//                 onClick={() => setActiveStep(0)}
//                 sx={{ textTransform: "none", borderColor: PRIMARY, color: PRIMARY, borderRadius: 2 }}
//               >
//                 Start New Run
//               </Button>
//               <Button
//                 variant="contained"
//                 onClick={handleSubmitForApproval}
//                 disabled={running || previewLoading || preview.length === 0}
//                 sx={{ backgroundColor: PRIMARY, textTransform: "none", borderRadius: 2, "&:hover": { backgroundColor: "#145016" } }}
//               >
//                 { running ? "Generating Payroll..." : "Submit for Approval" }
//               </Button>
//             </Box>
//           </>
//         )}
//       </Paper>

//       <PayrollBreakdownDialog 
//         open={breakdownOpen}
//         payroll={selectedPayroll}
//         onClose={() => {
//           setBreakdownOpen(false);
//           setSelectedPayroll(null);
//         }}
//       />
//     </Box>
//   );
// };

// export default PayrollProcessing;


import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  CalendarDays,
  Play,
  RefreshCw,
  Send,
  Eye,
} from "lucide-react";
import { toast } from "react-toastify";

import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import Table from "../../../components/Table/Table";

import usePayrollEntity from "../../../utils/usePayrollEntity";
import { fmtMoney } from "../../../utils/payrollFormat";
import { getLoggedInServiceNo } from "../../../utils/masterDataUtils";
import {
  calculatePayroll,
  getPayrollPreview,
  getPayrollBatchEmployees,
} from "../../../store/slices/payrollSlice";

import PayrollBreakdownDialog from "../../../components/PayRoll/PayrollBreakdownDialog";
import Toast from "../../../components/Toast/Toast";
import useToast from "../../../utils/useToast";
import PayrollApprovalProgressDialog, { APPROVAL_STATUS } from "../../../components/PayRoll/PayrollApprovalProgressDialog";
import payRollService from "../../../services/PayrollService";

const TABLE_PROPS = {
  search: true,
  searchLabel: "Search",
  pageSize: 10,
  scrollClassName: "",
  emptyMessage: "No payroll records found",
  loadingMessage: "Loading...",
};

const PayrollProcessing = () => {
  const dispatch = useDispatch();

  const [running, setRunning] = useState(false);

  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [selectedBatch, setSelectedBatch] = useState("");

  const [preview, setPreview] = useState([]);
  const [previewLoading, setPreviewLoading] = useState(false);

  const [breakdownOpen, setBreakdownOpen] = useState(false);
  const [selectedPayroll, setSelectedPayroll] = useState(null);

  const [batchEmployees, setBatchEmployees] = useState([]);
  const [batchEmployeesLoading, setBatchEmployeesLoading] = useState(false);

  const [approvalDialogOpen, setApprovalDialogOpen] = useState(false);
  const [approvalStatus, setApprovalStatus] = useState(APPROVAL_STATUS.IDLE);
  const [approvalError, setApprovalError] = useState('');

  const { list: periods } = usePayrollEntity("payrollPeriods");
  const { list: batches } = usePayrollEntity("batchManagement");

  const selectedPeriodObj = periods.find((p) => String(p.id) === String(selectedPeriod))

  const periodMeta = selectedPeriodObj
    ? {
        startDate: selectedPeriodObj.startDate,
        endDate: selectedPeriodObj.endDate,
        frequency: selectedPeriodObj.frequency === "Weekly" || selectedPeriodObj.frequency === "W" ? "W" : "M",
      }
    : null

  const { toast, showToast, hideToast } = useToast();

  /*
   * Load employees belonging to the selected batch.
   */
  useEffect(() => {
    if (!selectedBatch) {
      setBatchEmployees([]);
      return;
    }

    let cancelled = false;

    setBatchEmployeesLoading(true);

    dispatch(getPayrollBatchEmployees(selectedBatch))
      .then((list) => {
        if (!cancelled) {
          setBatchEmployees(list || []);
        }
      })
      .catch((error) => {
        console.error("Failed to load batch employees:", error);

        if (!cancelled) {
          setBatchEmployees([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setBatchEmployeesLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [selectedBatch, dispatch]);

  /*
   * Load preview whenever a payroll period is selected and
   * the preview is requested by the existing flow.
   */
  useEffect(() => {
    if (!selectedPeriod) {
      setPreview([]);
      return;
    }

    const loadPreview = async () => {
      setPreviewLoading(true);

      try {
        const result = await dispatch(
          getPayrollPreview(selectedPeriod, batchEmployees, periodMeta)
        );

        setPreview(result || []);

        if (!result || result.length === 0) {
          // toast.info(
          //   "No employees with salary were found for the selected payroll period."
          // );

          showToast("No employees with applicable salaries found for this period. Please ensure working days are configured.", 'warning');
        }
      } catch (error) {
        console.error("Payroll preview error:", error);

        setPreview([]);

        // toast.error(
        //   error?.message || "Failed to load payroll preview."
        // );

        showToast(error?.message || "Failed to load payroll preview.", 'error');
      } finally {
        setPreviewLoading(false);
      }
    };

    loadPreview();
  }, [selectedPeriod, batchEmployees, dispatch, selectedPeriodObj]);

  const filteredBatches = selectedPeriod
    ? batches.filter(
        (batch) =>
          String(batch.periodId) === String(selectedPeriod)
      )
    : batches;

  const totalGross = preview.reduce(
    (sum, row) => sum + Number(row.gross || 0),
    0
  );

  const totalNet = preview.reduce(
    (sum, row) => sum + Number(row.net || 0),
    0
  );

  const handlePeriodChange = (value) => {
    setSelectedPeriod(value);
    setSelectedBatch("");
    setPreview([]);
  };

  const handleOpenApprovalDialog = () => {
    if (!selectedPeriod) {
      showToast("Please select a payroll period.", "warning");
      return;
    }

    if (preview.length === 0) {
      showToast("There are no payroll records available for approval.", "warning");
      return;
    }

    setApprovalStatus(APPROVAL_STATUS.IDLE);
    setApprovalError('');
    setApprovalDialogOpen(true);
  }

  const handleExecuteSubmission = async () => {
    setRunning(true);

    try {
      // 1. Calculate payroll
      setApprovalStatus(APPROVAL_STATUS.GENERATING_PAYROLL);
      await dispatch(
        calculatePayroll(selectedPeriod, getLoggedInServiceNo())
      );

      // 2. Generate bank report transfer
      setApprovalStatus(APPROVAL_STATUS.GENERATING_BANK_REPORT);
      const bankResponse = await payRollService.GetBankReportDetailsByPeriodId(selectedPeriod);

      if (bankResponse && bankResponse.StatusCode !== 200) {
        throw new Error(bankResponse.Result || "Failed to generate bank report.");
      }

      // Finished successfully
      setApprovalStatus(APPROVAL_STATUS.COMPLETED);
      setPreview([]);
      setSelectedPeriod("");
      setSelectedBatch("");
      setBatchEmployees([]);
    } catch (error) {
      console.error("[Payroll Processing] Submission workflow failed: ", error);
      const backendMessage = 
        error?.response?.data?.Result || 
        error?.response?.data?.message || 
        error?.response?.data?.Message || 
        error?.message ||
        "";

      const msg = backendMessage.includes("HRM_MONTHLY_ALLOCATION")
        ? "Monthly allocation days are missing for one or more employee types"
        : backendMessage || "Failed to generate payroll";
      
      setApprovalError(msg);
      setApprovalStatus(APPROVAL_STATUS.FAILED); 
    } finally {
      setRunning(false);
    }
  }

  const handleRefreshPreview = async () => {
    if (!selectedPeriod) {
      // toast.warning("Please select a payroll period.");
      showToast("Please select a payroll period.", "warning");
      return;
    }

    setPreviewLoading(true);

    try {
      const result = await dispatch(
        getPayrollPreview(
          selectedPeriod,
          batchEmployees,
          periodMeta,
        )
      );

      setPreview(result || []);

      // toast.success("Payroll preview refreshed.", {
      //   autoClose: 1500,
      // });
      showToast("Payroll preview refreshed.", "success");
    } catch (error) {
      console.error("Payroll preview error:", error);

      // toast.error(
      //   error?.message || "Failed to refresh payroll preview."
      // );

      showToast(error?.message || "Failed to refresh payroll preview.", "error");
    } finally {
      setPreviewLoading(false);
    }
  };

  const handleSubmitForApproval = async () => {
    if (!selectedPeriod) {
      // toast.warning("Please select a payroll period.");
      showToast("Please select a payroll period.", "warning");
      return;
    }

    if (preview.length === 0) {
      // toast.warning(
      //   "There are no payroll records available for approval."
      // );
      showToast("There are no payroll records available for approval.", "warning");
      return;
    }

    setRunning(true);

    try {
      await dispatch(
        calculatePayroll(
          selectedPeriod,
          getLoggedInServiceNo()
        )
      );

      setPreview([]);

      // toast.success(
      //   "Payroll generated successfully. The payroll preview has been cleared.",
      //   { autoClose: 2500 }
      // );

      showToast("Payroll generated successfully. The payroll preview has been cleared.", "success");

      setSelectedPeriod("");
      setSelectedBatch("");
      setBatchEmployees([]);
    } catch (error) {
      console.error("Payroll generation error:", error);

      // toast.error(
      //   error?.response?.data?.message ||
      //     error?.response?.data?.Message ||
      //     error?.message ||
      //     "Failed to generate payroll."
      // );

      showToast(`${error?.response?.data?.message ||
          error?.response?.data?.Message ||
          error?.message ||
          "Failed to generate payroll."}`,"error")
    } finally {
      setRunning(false);
    }
  };

  return (
    <div className="space-y-4 p-6">
      <Breadcrumb
        trail={["Payroll", "Payroll Processing"]}
        title="Payroll Processing"
        subtitle="Generate payroll and review the final payroll results before approval."
      />

      {/* ─────────────────────────────────────────────────────────────
          Payroll Generation
      ───────────────────────────────────────────────────────────── */}
      <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
        <div className="px-5 py-4">
          <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">

            {/* Left: Title + Subtitle */}
            <div className="flex items-center gap-3">
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-primary-700">
                <CalendarDays size={18} />
              </div>

              <div>
                <h2 className="text-sm font-semibold text-gray-900">
                  Generate Payroll
                </h2>

                <p className="mt-0.5 text-xs text-gray-500">
                  Select a payroll period and generate the payroll calculation.
                </p>
              </div>
            </div>

            {/* Right: Payroll Period + Refresh Preview */}
            <div className="flex flex-col gap-3 sm:flex-row sm:items-end">

              {/* Payroll Period */}
              <div className="w-full sm:w-[280px]">
                <label
                  htmlFor="payroll-period"
                  className="mb-1.5 block text-xs font-medium text-gray-700"
                >
                  Payroll Period
                  <span className="ml-1 text-red-500">*</span>
                </label>

                <select
                  id="payroll-period"
                  value={selectedPeriod}
                  onChange={(e) =>
                    handlePeriodChange(e.target.value)
                  }
                  className="
                    h-10
                    w-full
                    rounded-md
                    border
                    border-gray-300
                    bg-white
                    px-3
                    text-sm
                    text-gray-700
                    outline-none
                    transition
                    focus:border-primary-600
                    focus:ring-1
                    focus:ring-primary-600
                  "
                >
                  <option value="">
                    Select Payroll Period
                  </option>

                  {periods
                    .filter((period) => period.status === "Active")
                    .map((period) => (
                      <option
                        key={period.id}
                        value={period.id}
                      >
                        {period.code} - {period.name}
                      </option>
                    ))}
                </select>
              </div>

              {/* Refresh Preview */}
              <button
                type="button"
                onClick={handleRefreshPreview}
                disabled={!selectedPeriod || previewLoading || running}
                className="
                  inline-flex
                  h-10
                  shrink-0
                  items-center
                  justify-center
                  gap-2
                  rounded-md
                  border
                  border-gray-300
                  bg-white
                  px-4
                  text-sm
                  font-medium
                  text-gray-600
                  transition-colors
                  hover:border-primary-600
                  hover:bg-primary-50
                  hover:text-primary-700
                  disabled:cursor-not-allowed
                  disabled:bg-gray-100
                  disabled:text-gray-400
                "
              >
                <RefreshCw
                  size={15}
                  className={previewLoading ? "animate-spin" : ""}
                />

                Refresh Preview
              </button>
            </div>
          </div>

          {/* Optional batch employee information */}
          {selectedBatch && (
            <p className="mt-3 text-xs text-gray-500">
              {batchEmployeesLoading
                ? "Loading batch employees..."
                : `${batchEmployees.length} active employee(s) in this batch.`}
            </p>
          )}
        </div>
      </div>


      {/* ─────────────────────────────────────────────────────────────
          Payroll Preview
      ───────────────────────────────────────────────────────────── */}
      <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
        <div className="flex flex-col gap-3 border-b border-gray-200 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h2 className="text-sm font-semibold text-gray-900">
              Payroll Preview
            </h2>

            <p className="mt-0.5 text-xs text-gray-500">
              Review calculated payroll amounts before submitting
              the run for approval.
            </p>
          </div>

          {preview.length > 0 && (
            <div className="flex flex-wrap items-center gap-5 text-right">
              <div>
                <p className="text-[11px] uppercase tracking-wide text-gray-400">
                  Employees
                </p>
                <p className="text-sm font-semibold text-gray-900">
                  {preview.length}
                </p>
              </div>

              <div>
                <p className="text-[11px] uppercase tracking-wide text-gray-400">
                  Gross
                </p>
                <p className="text-sm font-semibold text-gray-900">
                  {fmtMoney(totalGross)}
                </p>
              </div>

              <div>
                <p className="text-[11px] uppercase tracking-wide text-gray-400">
                  Net Pay
                </p>
                <p
                  className="text-sm font-semibold text-primary-700"
                >
                  {fmtMoney(totalNet)}
                </p>
              </div>
            </div>
          )}
        </div>

        {!selectedPeriod ? (
          <div className="px-5 py-12 text-center">
            <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 text-gray-400">
              <CalendarDays size={19} />
            </div>

            <p className="text-sm font-medium text-gray-700">
              Select a payroll period
            </p>

            <p className="mt-1 text-xs text-gray-500">
              Choose a payroll period above to generate and preview
              payroll.
            </p>
          </div>
        ) : (
          <>
            <Table
              {...TABLE_PROPS}
              loading={previewLoading}
              rows={preview}
              rowKey={(row) =>
                row.empNo || row.serviceNo || row.id
              }
              searchKeys={["empNo", "name"]}
              searchPlaceholder="Search employees..."
              columns={[
                {
                  key: "name",
                  label: "Employee",
                  grow: true,
                  className:
                    "font-semibold text-gray-900",
                  render: (r) =>
                    `${r.name} (${r.empNo})`,
                },
                // {
                //   key: "workingDays",
                //   label: "Working Days",
                //   align: "right",
                //   className: "text-gray-600 tabular-nums",
                //   render: (r) =>
                //     r.workingDays,
                // },
                {
                  key: "presentDays",
                  label: "Present",
                  align: "right",
                  className: "text-gray-600 tabular-nums",
                  render: (r) =>
                    r.presentDays,
                },
                {
                  key: "gross",
                  label: "Gross (Rs)",
                  align: "right",
                  className:
                    "font-semibold text-gray-900 tabular-nums",
                  render: (r) =>
                    fmtMoney(r.gross),
                },
                {
                  key: "totalDeductions",
                  label: "Deductions (Rs)",
                  align: "right",
                  className:
                    "text-gray-600 tabular-nums",
                  render: (r) =>
                    fmtMoney(r.totalDeductions),
                },
                {
                  key: "epf",
                  label: "EPF (Rs)",
                  align: "right",
                  className:
                    "text-gray-600 tabular-nums",
                  render: (r) =>
                    fmtMoney(r.epf),
                },
                {
                  key: "net",
                  label: "Net Pay (Rs)",
                  align: "right",
                  className:
                    "font-semibold text-gray-900 tabular-nums",
                  render: (r) =>
                    fmtMoney(r.net),
                },
                {
                  key: "breakdown",
                  label: "Breakdown",
                  align: "center",
                  render: (r) => (
                    <button
                      type="button"
                      onClick={() => {
                        setSelectedPayroll(r);
                        setBreakdownOpen(true);
                      }}
                      className="
                        inline-flex
                        h-8
                        items-center
                        gap-1.5
                        rounded-md
                        border
                        border-gray-200
                        px-2.5
                        text-xs
                        font-medium
                        text-gray-600
                        transition-colors
                        hover:border-primary-200
                        hover:bg-primary-50
                        hover:text-primary-700
                      "
                    >
                      <Eye size={14} />
                      View
                    </button>
                  ),
                },
              ]}
            />

            {preview.length > 0 && (
              <div className="flex flex-col gap-2 border-t border-gray-200 px-5 py-4 sm:flex-row sm:items-center sm:justify-end">
                <button
                  type="button"
                  onClick={() => {
                    setPreview([]);
                    setSelectedPeriod("");
                    setSelectedBatch("");
                    setBatchEmployees([]);
                  }}
                  disabled={running}
                  className="
                    inline-flex
                    items-center
                    justify-center
                    rounded-md
                    border
                    border-gray-300
                    bg-white
                    px-4
                    py-2.5
                    text-sm
                    font-medium
                    text-gray-600
                    transition-colors
                    hover:border-primary-600
                    hover:bg-primary-50
                    hover:text-primary-700
                    disabled:cursor-not-allowed
                    disabled:bg-gray-100
                    disabled:text-gray-400
                  "
                >
                  Start New Run
                </button>

                <button
                  type="button"
                  onClick={handleOpenApprovalDialog}
                  disabled={
                    running ||
                    previewLoading ||
                    preview.length === 0
                  }
                  className="
                    inline-flex
                    items-center
                    justify-center
                    gap-2
                    rounded-md
                    bg-primary-600
                    px-4
                    py-2.5
                    text-sm
                    font-medium
                    text-white
                    transition-colors
                    hover:bg-primary-700
                    disabled:cursor-not-allowed
                    disabled:bg-gray-300
                    disabled:text-gray-500
                  "
                >
                  {/*running ? (
                    <RefreshCw
                      size={15}
                      className="animate-spin"
                    />
                  ) : (
                    <Send size={15} />
                  )}

                  {running ? "Processing..." : "Submit for Approval" */}

                  <Send size={15} />
                  Submit for Approval
                </button>
              </div>
            )}
          </>
        )}
      </div>

      <PayrollBreakdownDialog
        open={breakdownOpen}
        payroll={selectedPayroll}
        onClose={() => {
          setBreakdownOpen(false);
          setSelectedPayroll(null);
        }}
      />

      <PayrollApprovalProgressDialog 
        open={approvalDialogOpen}
        status={approvalStatus}
        errorMessage={approvalError}
        onConfirm={handleExecuteSubmission}
        onClose={() => setApprovalDialogOpen(false)}
      />

      <Toast 
        message={toast?.message}
        type={toast?.type}
        onClose={hideToast}
      />
    </div>
  );
};

export default PayrollProcessing;